<div class="trigger" (click)="openToolbox()">
  @switch (triggerName) {
    @case ('ProductChooser') {
      <mat-icon svgIcon="products"></mat-icon>
      {{ 'i18n.toolbox.productChooser.triggerText' | translate }}
    }
    @case ('Layout') {
      <mat-icon svgIcon="layouts"></mat-icon>
      {{ 'i18n.toolbox.layout.triggerText' | translate }}
    }
    @case ('Preview') {
      <mat-icon svgIcon="preview"></mat-icon>
      {{ 'i18n.toolbox.preview.title' | translate }}
    }
  }
</div>
